export default "__VITE_ASSET__DrqQRddI__"